import { createMuiTheme } from "@material-ui/core/styles";
import _ from "lodash";
import { blue, red, indigo } from "@material-ui/core/colors";

const muiTheme = createMuiTheme();

const myTheme = {
  ...muiTheme,
  palette: {
    ..._.get(muiTheme, "palette"),
    primary: indigo,
    secondary: blue,
    error: red
  }
};

export default myTheme;
